import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NameAndPrice } from '../../../models/types';
import { MoreInfoTitleComponent } from '../more-info-title/more-info-title.component';
import { PricePipe } from '@lx/shared/ui/pipes';

@Component({
  standalone: true,
  imports: [CommonModule, MoreInfoTitleComponent, PricePipe],
  selector: 'lx-price-lists-portal-more-info-list',
  templateUrl: './more-info-list.component.html',
  styleUrls: ['./more-info-list.component.scss', './print-more-info-list.component.scss'],
})
export class MoreInfoListComponent {
  @Input() title!: string;
  @Input() moreInfoItems!: NameAndPrice[];
}
